import { Pipe, PipeTransform } from "@angular/core";
import { TenantUser } from "../../_objects/user";

@Pipe({
  name: "userNamePipe",
  standalone: false
})
export class CustomUserNamePipe implements PipeTransform {
  transform<T>(value: string, args?: TenantUser[]): string {
    if (!args || args.length < 1) {
      return value;
    }

    const user = args.find((arg) => arg.id === value);
    return user ? user.givenName + " " + user.surname : "Unknown User";
  }
}
